export default {
  // 商品模块获取商品列表数据
  getProducts: {
    method: 'get',
    url: 'platform/products'
  },
  // 商品详细信息
  productDetail: {
    method: 'get',
    url: 'sys/products/{id}'
  }
}
